import { getFile } from '@keepeek/api-client';
import Axios from 'axios';

/**
 * This will trigger refresh 120 seconds before file descriptor expiration
 */
var REFRESH_GAP_SECONDS = 120;
/**
 * Allow refresh only if interval between two refresh is equal or higher to 240 seconds
 */
var REFRESH_MINIMUM_GAP_SECONDS = 240;
/**
 * Schedule a file descriptor refresh
 */
function scheduleFileDescriptorRefresh(descriptor, onRefresh) {
    if (!descriptor || !descriptor.expirationDate || !descriptor.id) {
        return;
    }
    var expiration = new Date(descriptor.expirationDate).getTime();
    var now = Date.now();
    var delayMilliseconds = expiration - now - REFRESH_GAP_SECONDS * 1000;
    var fileId = descriptor.id;
    if (delayMilliseconds < REFRESH_MINIMUM_GAP_SECONDS * 1000) {
        console.debug("Not safe to refresh descriptor ".concat(descriptor.id, " every ").concat((delayMilliseconds / 1000).toFixed(2), "s"));
        return;
    }
    console.debug("Refresh descriptor ".concat(descriptor.id, " every ").concat((delayMilliseconds / 1000).toFixed(2), "s"));
    // Assume descriptor will have same expiration date interval, it avoid recursive
    // setTimeout calls.
    return setInterval(function () {
        getFile(Axios, {
            fileId: fileId,
            axiosRequestConfig: {
                // Ignore 404 errors in case descriptor already consumed
                disableNotificationErrorCodes: [404]
            }
        })
            .then(function (data) {
            console.debug("Descriptor ".concat(descriptor.id, " refreshed"));
            if (onRefresh) {
                // Trigger descriptor update
                onRefresh(data.data);
            }
        })["catch"](function (error) {
            console.error("Error refreshing descriptor ".concat(descriptor.id), error);
        });
    }, delayMilliseconds);
}

export { scheduleFileDescriptorRefresh };
//# sourceMappingURL=utils.js.map
